import waiarticle from '@/components/wai/article/index.vue'

export default {
    name: 'articlepage',
    components: {
        waiarticle
    },
    data : function(){

        return {
            sha : null,
            cuis : null
        }

    },

    created : function(){

        this.sha = null
        this.cuis = null

        if (this.$route.params.sha)
            this.sha = this.$route.params.sha

        if (this.$route.params.cuis)
            this.cuis = this.$route.params.cuis.split(',')
    },

    watch: {
        $route(to, from) {

            this.sha = null
            this.cuis = null

            if (this.$route.params.sha)
                this.sha = this.$route.params.sha

            if (this.$route.params.cuis)
                this.cuis = this.$route.params.cuis.split(',')
        }
    }
}